// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  /*position: fixed !important;*/
  background-color: #FFFFFF;

}
.global_container{
  width: 100vw;
  height: 90vh;
  margin-top: 0vh;
  background-color: #F0F0F3;
  border-radius: 30px 30px 0px 0px;
}
.global_container_dark{
  width: 100vw;
  height: 90vh;
  margin-top: 0vh;
  background-color: #1E2834;
  border-radius: 30px 30px 0px 0px;

}
.global_content_title{
  font-size: 26px;
  color:#585858;
}
.global_circle_btns{
width: 55px;
height: 55px;
border-radius: 300px;
border: 1px solid #ff4f4f;
box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4), -10px -10px 30px #FFFFFF;
  color: #ff4f4f;
  margin-left: 30px;
}
.global_circle_btns_dark{
  width: 55px;
  height: 55px;
  border-radius: 300px;
  background: #1E2834;
  border: 1.13105px solid #ea4335;
  box-sizing: border-box;
  box-shadow: 11.3105px 11.3105px 33.9316px rgba(0, 0, 0, 0.6), -4.52422px -4.52422px 18.0969px rgba(255, 255, 255, 0.12);
  }


input{
border: 1px solid red;
border-radius: 5px;
height: 30px;
padding-left: 10px;
}
.box-shadow{
  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4), -10px -10px 30px #FFFFFF;
}
label{
  margin-bottom: 2px;
  color: #FF5759;
}
.conditions{
  display: flex;
  flex-direction: column;
  margin-top: 1vh;
  overflow-y: scroll;
  width: 80%;
  height: 80%;
}
.TermsCondition{
  position: absolute;
  margin-top: -6vh;
}
.Modal {
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  background-color: white;
}

.Overlay {
  position: fixed;
  top: 20%;
  left: 0;
  right: 0;
  bottom: 20%;
  background-color: #F0F0F3;
  align-content: center;
  justify-content: center;
 text-align: center;
}
.btn_msgModal{
  display:inline-block;
  padding:0.35em 1.2em;
  border:0.1em solid #ea4335;;
  border-radius:1.12em;
  box-sizing: border-box;
  text-decoration:none;
  font-family:'Roboto',sans-serif;
  font-weight:300;
  color:#ea4335;
  text-align:center;
  transition: all 0.2s;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;;AAE3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gCAAgC;;AAElC;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;AACA,WAAW;AACX,YAAY;AACZ,oBAAoB;AACpB,yBAAyB;AACzB,6EAA6E;EAC3E,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;EACtB,uHAAuH;EACvH;;;AAGF;AACA,qBAAqB;AACrB,kBAAkB;AAClB,YAAY;AACZ,kBAAkB;AAClB;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;CACxB,kBAAkB;AACnB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["body{\n  /*position: fixed !important;*/\n  background-color: #FFFFFF;\n\n}\n.global_container{\n  width: 100vw;\n  height: 90vh;\n  margin-top: 0vh;\n  background-color: #F0F0F3;\n  border-radius: 30px 30px 0px 0px;\n}\n.global_container_dark{\n  width: 100vw;\n  height: 90vh;\n  margin-top: 0vh;\n  background-color: #1E2834;\n  border-radius: 30px 30px 0px 0px;\n\n}\n.global_content_title{\n  font-size: 26px;\n  color:#585858;\n}\n.global_circle_btns{\nwidth: 55px;\nheight: 55px;\nborder-radius: 300px;\nborder: 1px solid #ff4f4f;\nbox-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4), -10px -10px 30px #FFFFFF;\n  color: #ff4f4f;\n  margin-left: 30px;\n}\n.global_circle_btns_dark{\n  width: 55px;\n  height: 55px;\n  border-radius: 300px;\n  background: #1E2834;\n  border: 1.13105px solid #ea4335;\n  box-sizing: border-box;\n  box-shadow: 11.3105px 11.3105px 33.9316px rgba(0, 0, 0, 0.6), -4.52422px -4.52422px 18.0969px rgba(255, 255, 255, 0.12);\n  }\n\n\ninput{\nborder: 1px solid red;\nborder-radius: 5px;\nheight: 30px;\npadding-left: 10px;\n}\n.box-shadow{\n  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4), -10px -10px 30px #FFFFFF;\n}\nlabel{\n  margin-bottom: 2px;\n  color: #FF5759;\n}\n.conditions{\n  display: flex;\n  flex-direction: column;\n  margin-top: 1vh;\n  overflow-y: scroll;\n  width: 80%;\n  height: 80%;\n}\n.TermsCondition{\n  position: absolute;\n  margin-top: -6vh;\n}\n.Modal {\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  right: 40px;\n  bottom: 40px;\n  background-color: white;\n}\n\n.Overlay {\n  position: fixed;\n  top: 20%;\n  left: 0;\n  right: 0;\n  bottom: 20%;\n  background-color: #F0F0F3;\n  align-content: center;\n  justify-content: center;\n text-align: center;\n}\n.btn_msgModal{\n  display:inline-block;\n  padding:0.35em 1.2em;\n  border:0.1em solid #ea4335;;\n  border-radius:1.12em;\n  box-sizing: border-box;\n  text-decoration:none;\n  font-family:'Roboto',sans-serif;\n  font-weight:300;\n  color:#ea4335;\n  text-align:center;\n  transition: all 0.2s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
